<div
  class="bank-details-container"
  *ngIf="bankWiringInstructions || eftInstructions || onlineBanking || physicalCheck"
>
  <div class="bank-details-card-header">
    <h2 class="bank-details-title">{{ 'donate.bank.details' | translateLang }}</h2>
    <p class="bank-details-subtitle">{{ 'donate.bank.details.subtitle' | translateLang }}</p>
  </div>

  <ng-container *ngIf="!physicalCheck; else CheckInstructions">
    <!-- Online Banking / E-Transfer -->
    <div class="bank-details-section-card" *ngIf="onlineBanking">
      <div class="bank-details-section-header">
        <span class="bank-details-section-title">{{ 'donate.e.transfer' | translateLang }}</span>
        <span class="bank-details-section-type">{{
          'donate.online.banking.title' | translateLang
        }}</span>
      </div>
      <div class="bank-details-rows">
        <div class="bank-details-row">
          <span class="bank-details-label">{{ 'donate.e.transfer' | translateLang }}</span>
          <span class="bank-details-value">
            <a [href]="'mailto:' + cncfDonateEmail">{{ cncfDonateEmail }}</a>
          </span>
        </div>
        <div class="bank-details-row">
          <span class="bank-details-value">{{ 'donate.online.banking' | translateLang }}</span>
        </div>
      </div>
    </div>

    <!-- EFT -->
    <div class="bank-details-section-card" *ngIf="eftInstructions">
      <div class="bank-details-section-header">
        <span class="bank-details-section-title">{{
          'donate.eft.instructions' | translateLang
        }}</span>
        <span class="bank-details-section-type">{{
          'donate.eft.instructions' | translateLang
        }}</span>
      </div>
      <div class="bank-details-rows">
        <div class="bank-details-row" *ngIf="eftInstructions.bankName">
          <span class="bank-details-label">{{ 'donate.bank.name' | translateLang }}</span>
          <span class="bank-details-value">{{ eftInstructions.bankName }}</span>
        </div>
        <div class="bank-details-row" *ngIf="eftInstructions.accountName">
          <span class="bank-details-label">{{ 'donate.account.name' | translateLang }}</span>
          <span class="bank-details-value">{{ eftInstructions.accountName }}</span>
        </div>
        <div class="bank-details-row" *ngIf="eftInstructions.transit">
          <span class="bank-details-label">{{ 'donate.transit' | translateLang }}</span>
          <span class="bank-details-value">{{ eftInstructions.transit }}</span>
        </div>
        <div class="bank-details-row" *ngIf="eftInstructions.foundation">
          <span class="bank-details-label">{{ 'donate.foundation' | translateLang }}</span>
          <span class="bank-details-value">{{ eftInstructions.foundation }}</span>
        </div>
        <div class="bank-details-row" *ngIf="eftInstructions.accountNumber">
          <span class="bank-details-label">{{ 'donate.account.number' | translateLang }}</span>
          <span class="bank-details-value">{{ eftInstructions.accountNumber }}</span>
        </div>
        <div class="bank-details-row" *ngIf="eftInstructions.routingNumber">
          <span class="bank-details-label">{{ 'donate.routing.number' | translateLang }}</span>
          <span class="bank-details-value">{{ eftInstructions.routingNumber }}</span>
        </div>
      </div>
    </div>

    <!-- Wiring Instructions -->
    @if (bankWiringInstructions?.length) { @for (instruction of bankWiringInstructions; track
    instruction.currency) {
    <div class="bank-details-section-card">
      <div class="bank-details-rows">
        <!-- Header -->
        <div class="bank-details-section-header">
          <span class="bank-details-section-title">{{ instruction.currency }}</span>
          {{ 'donate.wiring.instructions' | translateLang }}
        </div>

        <!-- Details -->
        @if (instruction.fields?.length > 0) { @for (field of instruction.fields; track field.name)
        { @let isNote = ['_no_label_', 'donate.note'].includes(field.name);
        <div [ngClass]="isNote ? 'bank-details-section-field-note' : 'bank-details-section-field'">
          @if (!isNote) {
          <div>{{ 'contribute.confirmation.' + field.name | translateLang }}</div>
          } @if (isNote) {
          <div class="bank-details-note-content">
            <app-icon name="info-circle" color="#0a0a0a"></app-icon>
            <div class="bank-details-note-body">
              <div class="bank-details-note-header">
                <b>{{ 'donate.bank.details.please.note' | translateLang }}</b>
              </div>
              <div>{{ field.value }}</div>
            </div>
          </div>
          } @else {
          <div>{{ field.value }}</div>
          }
        </div>
        } }
        <!-- Details Swiss USD -->
        @if (instruction.instructionsSets?.length > 0) { @for (set of
        instruction.instructionsSets[0]; track set.name) { @let isNote = ['_no_label_',
        'donate.note'].includes(set.name);
        <div [ngClass]="isNote ? 'bank-details-section-field-note' : 'bank-details-section-field'">
          <div>
            @if (!isNote) {
            <div>
              {{ 'contribute.confirmation.' + set.name | translateLang }} @if (isWireRoutingNumber(set.name)) {
              {{ 'contribute.confirmation.donate.wire.routing.number.optional' | translateLang }}
              }
            </div>
            }
          </div>
          @if (isNote) {
          <div class="bank-details-note-content">
            <app-icon name="info-circle" color="#0a0a0a"></app-icon>
            <div class="bank-details-note-body">
              <div class="bank-details-note-header">
                <b>{{ 'donate.bank.details.please.note' | translateLang }}</b>
              </div>
              <div>{{ set.value | translateLang }}</div>
            </div>
          </div>
          } @else {
          <div>{{ set.value | translateLang }}</div>
          }
        </div>
        } }
      </div>
    </div>
    } }
  </ng-container>

  <ng-template #CheckInstructions>
    <div class="bank-details-section-card">
      <div class="bank-details-section-header">
        <span class="bank-details-section-title">{{
          'donate.physical.check.title' | translateLang
        }}</span>
        <span class="bank-details-section-type">{{
          'donate.physical.check.title' | translateLang
        }}</span>
      </div>
      <div class="bank-details-rows">
        <div class="bank-details-row">
          <span class="bank-details-label">{{ 'donate.check.payee' | translateLang }}</span>
          <span class="bank-details-value">{{ tenantName }}</span>
        </div>
        <div class="bank-details-row">
          <span class="bank-details-label">{{ 'donate.check.mail.to' | translateLang }}</span>
          <span class="bank-details-value">{{
            'donate.check.mail.to.address' | translateLang
          }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
